import { useState, createContext, useContext } from 'react';

type ICSContextType = {
  isFuture: boolean;
  setIsFuture: (isFuture: boolean) => void;
  card: string;
  setCard: (card: string) => void;
  // Tab state for initial response navigation (used by AI citations)
  initialResponseTab: string;
  setInitialResponseTab: (tab: string) => void;
  // Target phase for escalated response navigation (used by AI citations)
  targetPhase: number | null;
  setTargetPhase: (phase: number | null) => void;
  mode: string;
  setMode: (mode: string) => void;
};

const ICSContext = createContext<ICSContextType | undefined>(undefined);
export const useICSContext = (): ICSContextType => {
  const context = useContext(ICSContext);
  if (context === undefined) {
    throw new Error('useICSContext must be used within a ICSContextProvider');
  }
  return context;
};

const ICSContextProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [isFuture, setIsFuture] = useState<boolean>(true);
  const [card, setCard] = useState<string>('');
  const [initialResponseTab, setInitialResponseTab] = useState<string>('');
  const [targetPhase, setTargetPhase] = useState<number | null>(null);

  const [mode, setMode] = useState<string>('current');

  return (
    <ICSContext.Provider
      value={{
        isFuture,
        setIsFuture,
        card,
        setCard,
        initialResponseTab,
        setInitialResponseTab,
        targetPhase,
        setTargetPhase,
        mode,
        setMode,
      }}
    >
      {children}
    </ICSContext.Provider>
  );
};
export default ICSContextProvider;
